import { Controller } from "@hotwired/stimulus";

import axios from "axios";
import { tinymceInit } from "@/plugins/tinymce";

let loading = false;

export default class extends Controller {
  static targets = [
    "body",
    "officialDiscipline",
    "officialType",
    "trainerQualifications"
  ];

  formTargetConnected(element) {
    tinymceInit({
      toolbar: "bold italic underline strikethrough | removeformat"
    });

    const getRecipients = function () {
      const formData = [];
      Array.from(
        element.querySelectorAll(
          "[name='mass_mail[competition_division_difficulty_ids][]']:not(:disabled)"
        )
      ).forEach(el => {
        if (el.checked) {
          formData.push(el.value);
        }
      });

      $("#recipients").hide();
      $("#recipients_loader").show();

      if (!$("#recipient_rows").data("update-url")) {
        return;
      }
      axios({
        url: $("#recipient_rows").data("update-url"),
        method: "POST",
        data: {
          mass_mail: {
            competition_division_difficulty_ids: formData
          }
        },
        headers: {
          Accept: "application/json;charset=UTF-8;",
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
        }
      })
        .then(({ data }) => {
          // data is the object that contains all info returned
          let trHTML = "";
          if (data) {
            $.each(data, (i, item) => {
              trHTML +=
                '<tr><td><input type="checkbox" checked="true" class="recipient-email" name="mass_mail[recipient_person_ids][]" value="' +
                item.id +
                '"/> </td><td>' +
                item.name +
                "</td><td>" +
                item.email +
                "</td></tr>";
            });
          }

          return Promise.resolve(trHTML);
        })
        .then(html => {
          $("#recipient_rows").empty().append(html);
          countRecipients();

          $("#recipients_loader").hide();
          $("#recipients").show();
          $("#checkAllRecipients").prop("checked", true);
        })
        .catch(err => {
          console.error(err);
          alert("Tekkis viga. Palun proovi hiljem uuesti.");
        });
    };

    $(":checkbox[name='mass_mail[competition_division_difficulty_ids][]']").on(
      "change",
      getRecipients
    );

    $(".checkAllDifficulties").on("click", function (evt) {
      $(this)
        .closest("table")
        .find("tbody")
        .find(
          ":checkbox[name='mass_mail[competition_division_difficulty_ids][]']:not(:disabled)"
        )
        .prop("checked", $(this).prop("checked"));

      getRecipients(evt);
    });

    $("#checkAllRecipients").on("click", function (evt) {
      $(":checkbox.recipient-email:not(:disabled)").prop(
        "checked",
        $(this).prop("checked")
      );
      countRecipients();
      //getRecipients(evt);
    });

    const countRecipients = () => {
      const recipientCheckboxes = $(":checkbox.recipient-email");
      let recipientsCount = recipientCheckboxes.filter(":checked").length;
      $("#recipients_count").html(recipientsCount);
      recipientCheckboxes.on("change", function () {
        recipientsCount = recipientCheckboxes.filter(":checked").length;
        $("#recipients_count").html(recipientsCount);
      });
    };

    countRecipients();
  }

  officialDisciplineTargetConnected(el) {
    el.addEventListener("input", this.retrieveRecipientListsForCourseEvent);
  }

  officialTypeTargetConnected(el) {
    el.addEventListener("input", this.retrieveRecipientListsForCourseEvent);
  }

  trainerQualificationsTargetConnected(el) {
    $(el).on("change.select2", this.retrieveRecipientListsForCourseEvent);
  }

  async retrieveRecipientListsForCourseEvent() {
    if (loading) return;
    const search_official_type = Array.from(
      document.querySelectorAll(".search_official_type:checked")
    ).map(x => x.value);
    const search_official_discipline = Array.from(
      document.querySelectorAll(".search_official_discipline:checked")
    ).map(x => x.value);

    const search_trainer_qualifications = [];
    $(".search_trainer_qualifications")
      .select2("data")
      .forEach(item => {
        search_trainer_qualifications.push(item.id);
      });

    const search_trainer_specialized = [];
    $(".search_trainer_specialized")
      .select2("data")
      .forEach(item => {
        search_trainer_specialized.push(item.id);
      });
    loading = true;

    const url = document.querySelector(
      "[name='retrieve_participants_list']"
    ).value;

    await axios({
      url,
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      },
      data: {
        search: {
          official_type: search_official_type,
          official_discipline: search_official_discipline,
          trainer_qualifications: search_trainer_qualifications,
          trainer_specialized: search_trainer_specialized
        }
      }
    })
      .then(({ data: response }) => {
        Turbo.session.receivedMessageFromStream(response);
        loading = false;
      })
      .catch(err => {
        console.error(err);
        loading = false;
      });
  }
}
